/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';


@Injectable()
export class ErrorHandler {
  public handleError(response: HttpErrorResponse): any {
    return throwError(response.error || 'Server error');
  }
}
